const Scheduling = (function () {
  function loadSchedulingLanding() {
    const schedulingCalendarBtn = button.build({
      text: 'NEW! SCHEDULES',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-calendar');
        PROGRESS.SPINNER.show('Loading Schedule...');
        SchedulingCalendar.init();
      },
    });
    const schedulingCalendarWeb2CalBtn = button.build({
      text: 'View Calendar',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-calendar');
        PROGRESS.SPINNER.show('Loading Schedule...');
        schedulingCalendar.init();
      },
    });
    const schedulingRequestTimeOffBtn = button.build({
      text: 'Request Time Off',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-requestTimeOff');
        PROGRESS.SPINNER.show('Loading...');
        schedulingRequestTimeOff.init();
      },
    });
    const schedulingApproveRequestBtn = button.build({
      text: 'Approve Requests',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('scheduling-approveRequests');
        PROGRESS.SPINNER.show('Loading...');
        schedulingApproveRequest.init();
      },
    });
    const employeesTrainedByLocationBtn = button.build({
      text: 'Employees Trained by Location',
      style: 'secondary',
      type: 'contained',
      callback: function () {
        setActiveModuleSectionAttribute('employees-trained-by-location');
        PROGRESS.SPINNER.show('Loading...');
        EmployeesTrainedByLocation.init();
      },
    });

    var btnWrap = document.createElement('div');
    btnWrap.classList.add('landingBtnWrap');

    btnWrap.appendChild(schedulingCalendarBtn);
    if ($.session.schedulingSecurity && $.session.flag.trainedByLocation) {
      btnWrap.appendChild(employeesTrainedByLocationBtn);
    }

    btnWrap.appendChild(schedulingCalendarWeb2CalBtn);

    if ($.session.schedulingView && $.session.schedulingUpdate === false) {
    } else {
      btnWrap.appendChild(schedulingRequestTimeOffBtn);
      btnWrap.appendChild(schedulingApproveRequestBtn);
    }

    DOM.ACTIONCENTER.appendChild(btnWrap);
  }

  function init() {
    if (!$.session.schedulingUpdate) {
      setActiveModuleSectionAttribute('scheduling-calendar');
      SchedulingCalendar.init();
    } else {
      loadSchedulingLanding();
    }
  }

  return {
    init,
  };
})();

$.session.flag = {
  trainedByLocation: false, // [UNIT TESTING] T.162954
  copyShifts: false, // [DEV TESTING] T.162055
  overlapWarning: false, // [DEV TESTING] T.199582
  employeeFilter: false, // [DEV TESTING] T.198690
  196780: false, // [DEV TESTING] show "add new shift" popup on whitespace click
  200267: false, // [DEV TESTING] show open shift/appointment in month view popup
  186654: false, // [DEV TESTING] if last shift of month view deleted hide popup
  200249: false, // [DEV TESTING] emp temp disapears from shit
  // not using below flags unless I need too
  204977: false, // [DEV TESTING] ensure valid dates pub/unpub popup
};
